import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import TextField from "material-ui/TextField";
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import Dialog, { DialogTitle, DialogActions } from "material-ui/Dialog";
import Icon from 'material-ui/Icon'
import Button from "material-ui/Button";
import DatePicker from 'material-ui-pickers/DatePicker';
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from 'moment';
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import Select from "material-ui/Select";
import { CircularProgress } from "material-ui/Progress";
import { MenuItem } from "material-ui/Menu";
import { get, post } from '../../services/apiServices'
import { token, ttrToken } from '../../services/authServices'

const styles = {
    closeIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        color: '#a9a9a9',
        cursor: 'pointer'
    },
    editIcon: {
        padding: '10px',
        cursor: 'pointer'
    },
    button: {
        width: '120px',
        margin: '0 auto 40px'
    },
    titleWrap: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        color: '#3f51b5'
    },
    table: {
        minWidth: 700,
    },
    tableRow: {
        cursor: 'pointer'
    },
    listItem: {
        width: "480px",
        alignItems: "flex-start",
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
    },
    listItemText: {
        flex: "1 1 50%"
    },
    listItemTtitle: {
        fontWeight: 600
    },
    progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    }
};
class PlayerProgress extends Component {
    classes = this.props.classes;
    state = {
        openCreationModal: false,
        openWarningModal: false,
        mathCircleId: '',
        stageId: '',
        levelId: '',
        warningText: '',
        isFetching: false,
        isMakingPosts: false,
        firstName: '',
        lastName: '',
        accountName: '',
        selectedDate: moment().format('MM/DD/YYYY')
    }

    componentWillMount() {
        this.props.getStages()
    }

    renderStageItems = () => {
        let items = this.props.stages;
        let result = [];

        if (items && items.data && items.data.length)
            [
                items.data.map((item, index) => {
                    result.push(
                        <MenuItem key={index} value={item.id}>
                            {item.name}
                        </MenuItem>
                    );
                })
            ];

        return result;
    };

    renderLevelItems = () => {
        let stageId = this.state.stageId
        let stage = this.props.stages.data.find(e => e.id == stageId)

        let result = [];
        if (stage && stage.levels && stage.levels.length)
            [
                stage.levels.map((item, index) => {
                    result.push(
                        <MenuItem key={index} value={item.id}>
                            {item.order + ' - ' + item.description}
                        </MenuItem>
                    );
                })
            ];

        return result;
    };

    handleSelectStageChange = e => {
        this.setState({ stageId: e.target.value })
    };

    handleSelectLevelChange = e => {
        this.setState({ levelId: e.target.value })
    };

    handleSelectMathCircleIdChange = e => {
        this.setState({ mathCircleId: e.target.value })
    };

    async createPlayerProgress(e) {
        if (this.state.isMakingPosts) return

        this.setState({
            isMakingPosts: true
        })

        await post('/admin/plays/bulkstoreforuser', {
            mathCircleId: this.state.mathCircleId,
            ttrToken: ttrToken,
            levelId: this.state.levelId,
            stageId: this.state.stageId,
            date: this.state.selectedDate
        }, token)

        this.handleCloseModalConfirm();
    };

    handleCloseModalConfirm = () => {
        this.setState({
            openCreationModal: false,
            openWarningModal: false,
            isMakingPosts: false,
            firstName: '',
            lastName: '',
            accountName: '',
            selectedDate: moment().format('MM/DD/YYYY')
        })
    }

    handleDateChange = (e) => {
        this.setState({
            selectedDate: e.format('MM/DD/YYYY')
        })
    }

    async onCreatePlayerProgressClick() {
        if (!ttrToken) {
            this.setState({
                openWarningModal: true,
                warningText: 'Invalid admin account to use TTR API'
            })
        } else if (!this.state.mathCircleId) {
            this.setState({
                openWarningModal: true,
                warningText: 'Please fill Math Circle Id'
            })
        } else if (!this.state.stageId) {
            this.setState({
                openWarningModal: true,
                warningText: 'Please choose stage'
            })
        } else if (!this.state.levelId) {
            this.setState({
                openWarningModal: true,
                warningText: 'Please choose level'
            })
        } else if (!this.state.selectedDate) {
            this.setState({
                openWarningModal: true,
                warningText: 'Please choose playing date'
            })
        } else {
            try {
                let userResult = await post('/admin/users/by-mc-id', {
                    mathCircleId: this.state.mathCircleId,
                    ttrToken: ttrToken
                }, token);

                if (!userResult || !userResult.data) {
                    this.setState({
                        openWarningModal: true,
                        warningText: 'User cannot be found'
                    })
                } else {
                    let user = userResult.data

                    this.setState({
                        warningText: '',
                        openCreationModal: true,
                        firstName: user.first_name,
                        lastName: user.last_name,
                        accountName: user.account_name
                    })
                }
            } catch (e) {
                this.setState({
                    openWarningModal: true,
                    warningText: 'User cannot be found'
                })
            }
        }
    }

    render() {
        return this.state.isFetching ? (
            <div className={this.classes.progressWrapper}>
                <CircularProgress className={this.classes.progress} size={50} />
            </div>
        ) : (
                <div>
                    <div className={this.classes.titleWrap}>
                        <h2 className={this.props.classes.title}>Player Progress</h2>
                    </div>
                    <div className="input-wrap">
                        <FormControl className={this.classes.formControl} style={{ width: '25%' }}>
                            <TextField
                                type="text"
                                id="math_circle_id"
                                name="math_circle_id"
                                label="Math Circle Id"
                                onChange={(e) => this.handleSelectMathCircleIdChange(e)}
                            />
                        </FormControl>
                    </div>
                    <div className="input-wrap">
                        <FormControl className={this.classes.formControl} style={{ width: '25%', marginTop: '10px' }}>
                            <InputLabel htmlFor="type-select">
                                Stage
                            </InputLabel>
                            <Select
                                value={this.state.stageId || -1}
                                onChange={this.handleSelectStageChange}
                                inputProps={{
                                    id: "stage-select",
                                }}
                                autoWidth>
                                {this.renderStageItems()}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="input-wrap">
                        <FormControl className={this.classes.formControl} style={{ width: '25%', marginTop: '10px' }}>
                            <InputLabel htmlFor="type-select">
                                Level End
                            </InputLabel>
                            <Select
                                value={this.state.levelId || -1}
                                onChange={this.handleSelectLevelChange}
                                inputProps={{
                                    id: "level-select",
                                }}
                                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.42)' }}
                                autoWidth>
                                {this.renderLevelItems()}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="input-wrap">
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <DatePicker
                            value={this.state.selectedDate}
                            format='DD/MM/YYYY'
                            style={{ width: '25%', marginTop: '10px' }}
                            onChange={this.handleDateChange} />
                        </MuiPickersUtilsProvider>
                    </div>
                    <Button
                        variant="raised"
                        color="primary"
                        style={{ marginTop: '50px' }}
                        onClick={() => this.onCreatePlayerProgressClick()}>
                        Create player progress
                    </Button>
                    <Dialog
                        open={this.state.openWarningModal}
                        onClose={this.handleCloseModalConfirm}>
                        <DialogTitle>
                            <Icon
                                className={this.classes.closeIcon}
                                onClick={this.handleCloseModalConfirm}>
                                close
                        </Icon>
                            <br />
                            {this.state.warningText}
                        </DialogTitle>
                        <DialogActions className={this.classes.justifyCenter}>
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={this.handleCloseModalConfirm}>
                                OK
                        </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.state.openCreationModal}
                        onClose={this.handleCloseModalConfirm}>
                        <DialogTitle>
                            {!this.state.isMakingPosts && <Icon
                                className={this.classes.closeIcon}
                                onClick={this.handleCloseModalConfirm}>
                                close
                            </Icon>}
                            <br />
                            Are you sure you want create player progress for {this.state.firstName} {this.state.lastName}{this.state.accountName ? (' (' + this.state.accountName + ')') : ''}?
                            {this.state.isMakingPosts &&
                                <div style={{ textAlign: 'center' }}>
                                    <br />
                                    <CircularProgress className={this.classes.progress} size={50} />
                                    <div>Please wait...</div>
                                </div>}
                        </DialogTitle>
                        {!this.state.isMakingPosts &&
                            <DialogActions className={this.classes.justifyCenter}>
                                <Button
                                    variant="raised"
                                    color="primary"
                                    onClick={() => this.createPlayerProgress()}>
                                    Yes
                                </Button>
                                <Button
                                    variant="raised"
                                    color="primary"
                                    onClick={this.handleCloseModalConfirm}>
                                    No
                                </Button>
                            </DialogActions>}
                    </Dialog>
                </div>
            )
    }
}

export default withStyles(styles)(PlayerProgress);


// WEBPACK FOOTER //
// ./src/components/content/PlayerProgress.js